module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 020.7d0f0634.jpg";